import {logger} from '../../../logger';
import React, {useEffect, useRef, useState} from 'react';
import {PayPalScriptProvider, PayPalButtons, PayPalCardFieldsProvider, PayPalCardFieldsForm, PayPalNameField, PayPalNumberField, PayPalExpiryField, PayPalCVVField, usePayPalCardFields} from '@paypal/react-paypal-js';
import s from '../../s';
import * as Sentry from '@sentry/react';
import {currency, Portal} from '../../../util';
import {fetchWithAntiforgeryRetry} from '../../../global/antiforgery';
import {ICheckoutMessageType, ICheckoutStep, ICheckoutType} from '../../i';
import {isCheckoutRedesign} from '../../ab-redesign';
import {checkout} from '../../../api';

declare var modalOpen: any;
declare var OpenLink: any;
declare var paypal: any;
let set_apple_pay: number = 0;
let apple_pay_loaded: number = 0;
let applePayClickHandler: ((this: HTMLElement, ev: MouseEvent) => any) | null = null;
const ppa_debug: boolean = false;
declare var paypal_client_id: string;

const initialOptions = {
    clientId: paypal_client_id,
    currency: 'USD',
    intent: 'capture',
    components: 'card-fields,buttons,applepay,funding-eligibility',
    'enable-funding': 'venmo,paylater',
};

// The redesign's Billing address card: "Same as shipping address" reads the shipping address live, otherwise its own form.
// The control reads billing.addr, which the server fills from shipping when the shopper kept the same-as-shipping box ticked.
const billingAddr = () => (isCheckoutRedesign(s.checkout.isMyFrames) && s.checkout.billing.addrSameAsShip ? s.checkout.ship.addr : s.checkout.billing.addr);

// Redesign payment-option glyphs, inlined from the design file: the Font Awesome kit used by the site
// does not ship the `fa-cc-*` brand glyphs (they render 0x0), and the kit may not carry a credit-card
// glyph either, so the SVGs are embedded rather than looked up.
const PayPalGlyph = () => (
    <svg
        className="ab-pay-opt-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden={true}
        focusable="false"
    >
        <path
            d="M18.9663 1.86811C17.8777 0.60596 15.9098 0.0648477 13.3924 0.0648477H6.08617C5.83708 0.0648086 5.59616 0.155182 5.40673 0.319713C5.2173 0.484243 5.0918 0.712131 5.05281 0.962384L2.01062 20.5889C1.95016 20.9759 2.24477 21.3264 2.63039 21.3264H7.14102L8.27383 14.0174L8.23867 14.2463C8.31938 13.7297 8.75375 13.3486 9.26812 13.3486H11.4116C15.6223 13.3486 18.9195 11.6088 19.8826 6.57608C19.9112 6.42723 19.9359 6.28236 19.9573 6.14082C19.8358 6.07534 19.8358 6.07534 19.9573 6.14082C20.2441 4.28066 19.9554 3.01446 18.9663 1.86811Z"
            fill="#27346A"
        />
        <path
            d="M9.99977 5.47073C10.123 5.41091 10.2579 5.37995 10.3945 5.38013H16.1225C16.8008 5.38013 17.4334 5.42503 18.0116 5.51968C18.1733 5.54594 18.3343 5.57727 18.4941 5.61362C18.7207 5.66449 18.9447 5.72673 19.1652 5.80013C19.4495 5.89669 19.7141 6.00914 19.9574 6.14082C20.2441 4.27995 19.9554 3.01446 18.9663 1.86811C17.877 0.60596 15.9098 0.0648477 13.3924 0.0648477H6.08555C5.57109 0.0648477 5.13344 0.445828 5.05281 0.962384L2.01063 20.5882C1.95016 20.9758 2.24477 21.3258 2.62977 21.3258H7.14102L9.49125 6.1653C9.51438 6.01629 9.57274 5.87523 9.66132 5.75424C9.7499 5.63325 9.86605 5.53596 9.99977 5.47073Z"
            fill="#27346A"
        />
        <path
            d="M19.8826 6.57608C18.9195 11.6081 15.6224 13.3486 11.4116 13.3486H9.2675C8.75313 13.3486 8.31867 13.7297 8.23875 14.2463L6.82945 23.3341C6.7768 23.6728 7.0343 23.9797 7.37117 23.9797H11.1735C11.3913 23.9797 11.602 23.9006 11.7676 23.7566C11.9332 23.6127 12.0428 23.4134 12.0769 23.1946L12.1139 22.9975L12.8305 18.3774L12.8767 18.1221C12.9108 17.9032 13.0204 17.7039 13.186 17.56C13.3516 17.4161 13.5622 17.337 13.78 17.3369H14.3491C18.0324 17.3369 20.9166 15.8147 21.7594 11.4124C22.1112 9.57266 21.9291 8.03666 20.9985 6.95777C20.7163 6.63099 20.3657 6.36111 19.9573 6.14082C19.9352 6.28307 19.9113 6.42723 19.8826 6.57608Z"
            fill="#2790C3"
        />
        <path
            d="M18.9494 5.73203C18.7992 5.68742 18.6476 5.64793 18.4948 5.61362C18.3349 5.57785 18.174 5.54673 18.0123 5.52032C17.4335 5.42503 16.8013 5.38005 16.1224 5.38005H10.3952C10.2585 5.37982 10.1235 5.41104 10.0004 5.47136C9.8665 5.53636 9.7502 5.63358 9.66158 5.75461C9.57295 5.87564 9.51468 6.01683 9.4918 6.16593L8.27445 14.0174L8.2393 14.2463C8.31938 13.7297 8.75375 13.3486 9.2682 13.3486H11.4123C15.623 13.3486 18.9201 11.6088 19.8832 6.57608C19.9119 6.42723 19.9359 6.28299 19.958 6.14082C19.7142 6.00996 19.4501 5.89661 19.1659 5.80077C19.0941 5.77657 19.022 5.75366 18.9495 5.73203"
            fill="#1F264F"
        />
    </svg>
);

const CreditCardGlyph = () => (
    <svg
        className="ab-pay-opt-icon"
        width="27"
        height="24"
        viewBox="0 0 27 24"
        fill="none"
        aria-hidden={true}
        focusable="false"
    >
        <path
            d="M24 3.75C24.4125 3.75 24.75 4.0875 24.75 4.5V6H2.25V4.5C2.25 4.0875 2.5875 3.75 3 3.75H24ZM24.75 10.5V19.5C24.75 19.9125 24.4125 20.25 24 20.25H3C2.5875 20.25 2.25 19.9125 2.25 19.5V10.5H24.75ZM3 1.5C1.34531 1.5 0 2.84531 0 4.5V19.5C0 21.1547 1.34531 22.5 3 22.5H24C25.6547 22.5 27 21.1547 27 19.5V4.5C27 2.84531 25.6547 1.5 24 1.5H3ZM5.625 15.75C5.00156 15.75 4.5 16.2516 4.5 16.875C4.5 17.4984 5.00156 18 5.625 18H7.875C8.49844 18 9 17.4984 9 16.875C9 16.2516 8.49844 15.75 7.875 15.75H5.625ZM11.625 15.75C11.0016 15.75 10.5 16.2516 10.5 16.875C10.5 17.4984 11.0016 18 11.625 18H16.875C17.4984 18 18 17.4984 18 16.875C18 16.2516 17.4984 15.75 16.875 15.75H11.625Z"
            fill="#1C44AB"
        />
    </svg>
);

// Matches .ab-field .form-control. Applied inside the PayPal card-field iframes.
const cardFieldStyle = {
    input: {
        appearance: 'none',
        background: '#fff',
        border: '1px solid #d9d9d9',
        'border-radius': '4px',
        'box-shadow': 'none',
        color: '#171717',
        'font-family': "'Poppins', Roboto, 'Open Sans', 'Proxima Nova', sans-serif",
        'font-size': '16px',
        height: '44px',
        'line-height': '22px',
        outline: 'none',
        padding: '0 12px',
    },
    ':focus': {
        border: '1px solid #223658',
        'box-shadow': '0 0 0 1px #223658',
        outline: 'none',
    },
    '::placeholder': {
        color: '#a3a3a3',
    },
    '.invalid': {
        color: '#171717',
        border: '1px solid #b3261e',
    },
};

const SubmitPayment = ({isPaying, setIsPaying, billingAddress}) => {
    const {cardFieldsForm, fields} = usePayPalCardFields();

    const handleClick = async () => {
        if (!cardFieldsForm) {
            const childErrorMessage = 'Unable to find any child components in the <PayPalCardFieldsProvider />';

            throw new Error(childErrorMessage);
        }
        const formState = await cardFieldsForm.getState();

        if (!formState.isFormValid) {
            return alert('The payment form is invalid');
        }
        setIsPaying(true);
        s.checkout.messages = [];
        s.uiCheckout.processing = true;

        const addr = billingAddr();
        var ba = {
            addressLine1: addr.address1.value,
            addressLine2: addr.address2.value,
            adminArea1: addr.city.value,
            adminArea2: addr.state.value,
            countryCode: addr.country.value,
            postalCode: addr.postalCode.value,
        };

        // @ts-ignore
        cardFieldsForm.submit({ba}).catch(err => {
            setIsPaying(false);
            s.uiCheckout.processing = false;
            if (ppa_debug) {
                logger.log(err);
            }
            if (s.checkout.cstep === ICheckoutStep.payment) {
                // PayPal refused this payer or card (a risk or eligibility decision, not a typo): its raw JSON helps nobody.
                const refused = /PAYER_CANNOT_PAY|INSTRUMENT_DECLINED/.test(String(err?.message ?? err));
                s.checkout.messages.push({
                    msg: refused
                        ? "This payment method can't be used for this order. Please try a different card or payment method."
                        : `Payment Error. Check the credit card number. Details: ${err}`,
                    msgType: ICheckoutMessageType.payment,
                });
            }

            try {
                Sentry.captureException(err);
            } catch (err2) {}
        });
    };

    if (isCheckoutRedesign(s.checkout.isMyFrames)) {
        return (
            <button
                type="button"
                className="btn-checkout btn-checkout-yellow ab-pay-now"
                onClick={handleClick}
                disabled={s.uiCheckout.processing}
                aria-busy={s.uiCheckout.processing}
            >
                Pay Now
                {s.uiCheckout.processing && (
                    <span className="pad-left">
                        <i
                            className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"
                            aria-hidden={true}
                        ></i>
                    </span>
                )}
            </button>
        );
    }

    return (
        <button
            onClick={handleClick}
            style={{
                position: 'relative',
                width: '100%',
                boxSizing: 'border-box',
                verticalAlign: 'top',
                cursor: 'pointer',
                backgroundColor: '#299976',
                color: '#FFF',
                height: '62px',
            }}
        >
            {/* {isPaying ? <div className="spinner tiny" /> : } */}
            <div
                style={{
                    position: 'relative',
                    margin: '0px 4vw',
                    cursor: 'pointer',
                    color: '#FFF',
                    textAlign: 'center',
                    fontSize: '22px',
                }}
            >
                Pay Now
                {s.uiCheckout.processing && (
                    <span className="pad-left">
                        <i
                            className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"
                            aria-hidden={true}
                        ></i>
                    </span>
                )}
            </div>
        </button>
    );
};

/**
 * POST /api/pay/create and resolve its answer. Shared by the SDK's createOrder callback (both arms; it adds the generic
 * error handling) and the redesign's covered-order "Place Order".
 * Resolves to the PayPal order id to approve, or to '' when the server created the order itself and /view-order is
 * opening: pay.cs skipPayment (a gift card or promo code covers the total, or a marketing test order) answers
 * {isSuccess: true, custom_url: '/view-order', custom_msg: 'dd'} with NO custom_value, so that answer is handled before
 * the missing-order-id guard. Rejects when no order was created, after pushing any server error message.
 */
export function requestPayPalOrder(): Promise<string> {
    // console.log('createOrder');
    s.checkout.messages = [];
    // All four pay calls: the wrapper sends the token and retries a stale one once; when it cannot, it throws rather than
    // handing the marked 400 ({"antiforgery": ...}) to .json() as if it were a pay answer.
    return fetchWithAntiforgeryRetry('/api/pay/create', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: '',
    })
        .then(response => response.json())
        .then(order => {
            // console.log(order);
            if (!order.isSuccess) {
                s.uiCheckout.processing = false;

                if (order.reset_payment === true && order.custom_msg === 'shipping') {
                    s.checkout.ship.messages.push({
                        msg: order.errors,
                        msgType: ICheckoutMessageType.oci,
                    });
                    s.checkout.messages = [];
                    s.reset_payment = true;
                    s.moveStep(ICheckoutStep.oci);
                    s.checkout.messages = [];
                    return '';
                } else if (order.reset_payment === true) {
                } else {
                    s.checkout.messages.push({
                        msg: order.errors,
                        msgType: ICheckoutMessageType.payment,
                    });
                }

                throw new Error('Create order did not return an orderId');
                // return order.custom_value;
            } else if (order.custom_url === '/view-order' && order.custom_msg === 'dd') {
                OpenLink(order.custom_url);
                return '';
            } else if (!order?.custom_value) {
                throw new Error('Missing order id');
            } else {
                // console.log('orderId', order.custom_value);
                return order.custom_value;
            }
        });
}

/** Redesign covered-order note: which applied code(s) bring the total to zero. */
export function coveredOrderNote(giftCovers: boolean, promoCovers: boolean): string {
    const by = giftCovers && promoCovers ? 'gift card and promo code cover' : giftCovers ? 'gift card covers' : 'promo code covers';
    return `Your ${by} the order total. No payment is due.`;
}

export default function App() {
    const [appleDisabled, setappleDisabled] = useState(false);
    const [appleLive, setappleLive] = useState(false);
    const [isPaying, setIsPaying] = useState(false);
    const [method, setMethod] = useState<'paypal' | 'card'>('card');
    const [billingAddress, setBillingAddress] = useState({
        addressLine1: s.checkout.billing.addr.address1.value,
        addressLine2: s.checkout.billing.addr.address2.value,
        adminArea1: s.checkout.billing.addr.city.value,
        adminArea2: s.checkout.billing.addr.state.value,
        countryCode: s.checkout.billing.addr.country.value,
        postalCode: s.checkout.billing.addr.postalCode.value,
    });
    const mountedRef = useRef(true);
    const appleRetryTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const scheduleAppleRetry = (fn: () => void) => {
        if (!mountedRef.current) return;
        if (appleRetryTimerRef.current) {
            clearTimeout(appleRetryTimerRef.current);
        }
        appleRetryTimerRef.current = setTimeout(() => {
            appleRetryTimerRef.current = null;
            if (mountedRef.current) {
                fn();
            }
        }, 1000);
    };

    useEffect(() => {
        mountedRef.current = true;
        apple_init();
        return () => {
            mountedRef.current = false;
            if (appleRetryTimerRef.current) {
                clearTimeout(appleRetryTimerRef.current);
                appleRetryTimerRef.current = null;
            }
            if (applePayClickHandler) {
                document.getElementById('btn-appl')?.removeEventListener('click', applePayClickHandler);
                applePayClickHandler = null;
            }
        };
        // Mount-once Apple Pay init; apple_init is intentionally not a hook dependency.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function apple_init() {
        if (ppa_debug) {
            logger.log('ApplePay: apple_init');
        }

        async function apple_step1() {
            if (!mountedRef.current) return;

            const canShow = showApple();
            try {
                if (paypal == undefined || paypal === 'undefined' || !paypal) {
                    scheduleAppleRetry(apple_step1);
                    if (ppa_debug) {
                        logger.log('ApplePay: apple_step1_retry 1 sec: paypal missing');
                    }
                    setappleLive(false);
                    return;
                } else if (s.checkout.cstep !== ICheckoutStep.payment) {
                    scheduleAppleRetry(apple_step1);
                    if (ppa_debug) {
                        logger.log(`ApplePay: apple_step1_retry 1 sec: checkout step ${s.checkout.cstep}`);
                    }
                    setappleLive(false);
                    return;
                }
            } catch (err) {
                scheduleAppleRetry(apple_step1);
                if (ppa_debug) {
                    logger.log(`ApplePay: apple_step1_retry 1 sec: ${err}`);
                }
                setappleLive(false);
                return;
            }

            if (ppa_debug) {
                logger.log('ApplePay: step 1 -> step 2');
            }

            try {
                if (!window.ApplePaySession || !ApplePaySession) {
                    if (ppa_debug) {
                        logger.log('ApplePay: no apple 3');
                    }
                    setappleDisabled(true);
                    setappleLive(false);
                    if (canShow) {
                        scheduleAppleRetry(apple_step1);
                    } else {
                        document.getElementById('applepay-outer')?.remove();
                    }
                    return;
                }
            } catch {
                if (ppa_debug) {
                    logger.log('ApplePay: no apple 2');
                }
                setappleDisabled(true);
                setappleLive(false);
                if (canShow) {
                    scheduleAppleRetry(apple_step1);
                } else {
                    document.getElementById('applepay-outer')?.remove();
                }
                return;
            }
            if (set_apple_pay !== 1 && window.ApplePaySession && ApplePaySession && ApplePaySession?.supportsVersion(4) && ApplePaySession?.canMakePayments()) {
                try {
                    await apple_step2();
                    if (!mountedRef.current) return;
                    set_apple_pay = 1;
                } catch (err) {
                    if (!mountedRef.current) return;
                    set_apple_pay = 0;
                    if (ppa_debug) {
                        logger.log(`ApplePay: apple error 4: ${err}`);
                    }
                    if (canShow) {
                        scheduleAppleRetry(apple_step1);
                    } else {
                        document.getElementById('applepay-outer')?.remove();
                    }
                    setappleDisabled(true);
                    setappleLive(false);
                }
            } else {
                if (ppa_debug) {
                    logger.log('ApplePay: no apple 5');
                }
                if (canShow) {
                    scheduleAppleRetry(apple_step1);
                } else {
                    document.getElementById('applepay-outer')?.remove();
                }
                setappleDisabled(true);
                setappleLive(false);
                return;
            }
        }

        try {
            if (ppa_debug) {
                logger.log('ApplePay: apple_step1 first call');
            }
            setappleLive(true);
            apple_step1();
        } catch (err) {
            if (ppa_debug) {
                logger.log('ApplePay: error 1234342');
            }
            if (ppa_debug) {
                logger.log(err);
            }
        }
    }

    async function apple_step2() {
        if (!mountedRef.current) return;

        const applepay = paypal.Applepay();
        const {isEligible, countryCode, currencyCode, merchantCapabilities, supportedNetworks} = await applepay.config();

        if (!mountedRef.current) return;

        if (!isEligible) {
            if (ppa_debug) {
                logger.log('ApplePay: no apple 2');
            }
            setappleDisabled(true);
            return;
        }
        if (ppa_debug) {
            logger.log('ApplePay: applepay setup 1');
        }

        let sessionActive: boolean = false;

        async function onClick() {
            if (ppa_debug) {
                logger.log({merchantCapabilities, currencyCode, supportedNetworks});
            }
            if (ppa_debug) {
                logger.log('ApplePay: onClick');
            }

            // addressLine1: s.checkout.billing.addr.address1.value,
            // addressLine2: s.checkout.billing.addr.address2.value,
            // adminArea1: s.checkout.billing.addr.city.value,
            // adminArea2: s.checkout.billing.addr.state.value,
            // countryCode: s.checkout.billing.addr.country.value,
            // postalCode: s.checkout.billing.addr.postalCode.value,

            var _lines: any[] = [];
            _lines.push({
                label: 'Bag Subtotal',
                type: 'final',
                amount: s.checkout.cart.pricing.subtotal - s.checkout.cart.pricing.discount < 0 ? 0 : (s.checkout.cart.pricing.subtotal - s.checkout.cart.pricing.discount).toFixed(2),
            });
            _lines.push({
                label: 'Shipping',
                type: 'final',
                amount: (s.checkout.cart.pricing.shipping + s.checkout.cart.pricing.production).toFixed(2),
            });
            _lines.push({
                label: 'Tax',
                type: 'final',
                amount: s.checkout.cart.pricing.tax.toFixed(2),
            });

            const billing = billingAddr();
            const paymentRequest = {
                countryCode,
                currencyCode: 'USD',
                merchantCapabilities,
                supportedNetworks,
                requiredBillingContactFields: ['name', 'postalAddress'] as any[],
                requiredShippingContactFields: [],
                billingContact: {
                    givenName: billing.firstName.value,
                    familyName: billing.lastName.value,
                    addressLines: billing.address2.value !== '' ? [billing.address1.value, billing.address2.value] : [billing.address1.value],
                    locality: billing.city.value,
                    postalCode: billing.postalCode.value,
                    administrativeArea: billing.state.value,
                    country: billing.country.value,
                    countryCode: billing.country.value,
                    emailAddress: s.checkout.email.value,
                    phoneNumber: s.checkout.phone.value,
                },
                lineItems: _lines,
                ApplePayShippingType: 'shipping',
                total: {
                    label: Portal?.PortalID === 0 ? 'diplomaframe.com' : Portal?.PortalID === 1 ? 'customframes.com' : 'militaryframes.com',
                    amount: s.checkout.cart.pricing.total.toFixed(2),
                    type: 'final',
                } as any,
            };
            if (ppa_debug) {
                logger.log('ApplePay:  paymentRequest');
            }
            if (ppa_debug) {
                logger.log(paymentRequest);
            }

            let session = new ApplePaySession(4, paymentRequest);
            if (ppa_debug) {
                logger.log('ApplePay:  session');
            }

            if (ppa_debug) {
                logger.log('ApplePay:  onClick 1');
            }
            session.onvalidatemerchant = event => {
                applepay
                    .validateMerchant({
                        validationUrl: event.validationURL,
                    })
                    .then(payload => {
                        session.completeMerchantValidation(payload.merchantSession);
                        if (ppa_debug) {
                            logger.log('ApplePay:  completeMerchantValidation');
                        }
                    })
                    .catch(err => {
                        // todo debug ?
                        logger.error(err);
                        session.abort();
                        sessionActive = false;
                        // alert(err);
                    });
            };

            if (ppa_debug) {
                logger.log('ApplePay: onClick 2');
            }
            session.onpaymentmethodselected = () => {
                if (ppa_debug) {
                    logger.log('ApplePay: onpaymentmethodselected');
                }
                session.completePaymentMethodSelection({
                    newTotal: paymentRequest.total,
                });
            };

            session.onpaymentauthorized = async event => {
                try {
                    /* Create Order on the Server Side */
                    if (ppa_debug) {
                        logger.log('ApplePay: onpaymentauthorized 1');
                    }
                    const orderResponse = await fetchWithAntiforgeryRetry(`/api/pay/create`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: '',
                    });
                    //   if(!orderResponse.ok) {
                    //       throw new Error("error creating order")
                    //   }

                    if (ppa_debug) {
                        logger.log('ApplePay: onpaymentauthorized 2');
                    }

                    var _temp: any = await orderResponse.json();
                    const orderId = _temp.custom_value;
                    if (ppa_debug) {
                        logger.log(`ApplePay: onpaymentauthorized 2b: ${orderId}`);
                    }
                    /**
                     * Confirm Payment
                     */
                    await applepay.confirmOrder({
                        orderId: orderId,
                        token: event.payment.token,
                        billingContact: event.payment.billingContact,
                        shippingContact: event.payment.shippingContact,
                    });
                    if (ppa_debug) {
                        logger.log('ApplePay: onpaymentauthorized 3');
                    }
                    /*
                     * Capture order (must currently be made on server)
                     */
                    const approveResponse = await fetchWithAntiforgeryRetry(`/api/pay/approve`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({OrderID: orderId}),
                    });
                    logger.log(approveResponse);
                    session.completePayment({
                        status: window.ApplePaySession.STATUS_SUCCESS,
                    });

                    let r: any = await approveResponse.json();

                    if (ppa_debug) {
                        logger.log('ApplePay: onpaymentauthorized 4');
                    }

                    if (!r.isSuccess) {
                        s.uiCheckout.processing = false;
                        s.checkout.messages = [];
                        s.checkout.messages.push({
                            msg: r.errors,
                            msgType: ICheckoutMessageType.payment,
                        });
                        sessionActive = false;

                        if (r.reset_payment === true) {
                            s.reset_payment = true;
                            r.new_checkout_step = 2;
                        }

                        if (r.new_checkout_step > 0) {
                            s.moveStep(r.new_checkout_step);
                            s.checkout.CheckoutType = ICheckoutType.normal;

                            if (r.errors === 'missing-shipping') {
                                s.checkout.force_normal_checkout = true;
                                s.checkout.missing_shipping_info = true;
                                modalOpen('modal-missing-shipping');
                            }
                        }
                    } else {
                        OpenLink(r.custom_url);
                    }
                } catch (err) {
                    // alert(err);
                    logger.error(err); // todo debug?
                    session.completePayment({
                        status: window.ApplePaySession.STATUS_FAILURE,
                    });
                    sessionActive = false;
                }
            };

            session.oncancel = () => {
                if (ppa_debug) {
                    logger.log('ApplePay: Cancelled');
                }
                sessionActive = false;
            };

            if (sessionActive) {
                return;
            }

            session.begin();
            sessionActive = true;
        }

        if (ppa_debug) {
            logger.log('ApplePay: Elements 1');
        }
        if (!mountedRef.current) return;
        (document.getElementById('applepay-container') as HTMLElement).innerHTML = '<apple-pay-button id="btn-appl" buttonstyle="black" type="buy" locale="en" style="width:100%;margin-top:-4px;">';
        if (applePayClickHandler) {
            document.getElementById('btn-appl')?.removeEventListener('click', applePayClickHandler);
        }
        applePayClickHandler = onClick;
        document.getElementById('btn-appl')?.addEventListener('click', onClick);
        if (ppa_debug) {
            logger.log('ApplePay: Elements 2');
        }
        apple_pay_loaded = 1;
    }

    function showApple(): boolean {
        return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    // Promise<any> as before: the SDK callback type wants Promise<string>, and the catch below resolves undefined on an error.
    function createOrder(): Promise<any> {
        return requestPayPalOrder().catch(error => {
            logger.log(error);
            s.checkout.messages = [];
            if (ppa_debug) {
                logger.log(error);
            }

            if (s.checkout.cstep === ICheckoutStep.payment) {
                s.checkout.messages.push({
                    msg: 'Payment Error. Check the credit card number.',
                    msgType: ICheckoutMessageType.payment,
                });
            }
        });
    }

    function onApprove(data) {
        // console.log('onApprove');
        return fetchWithAntiforgeryRetry('/api/pay/approve', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({OrderID: data.orderID}),
        })
            .then(response => response.json())
            .then(r => {
                if (!r.isSuccess) {
                    s.uiCheckout.processing = false;
                    s.checkout.messages.push({
                        msg: r.errors,
                        msgType: ICheckoutMessageType.payment,
                    });
                    if (r.reset_payment === true) {
                        s.reset_payment = true;
                        // todo reset paypal advanced
                    }

                    if (r.new_checkout_step > 0) {
                        s.moveStep(r.new_checkout_step);
                        s.checkout.CheckoutType = ICheckoutType.normal;

                        if (r.errors === 'missing-shipping') {
                            s.checkout.force_normal_checkout = true;
                            s.checkout.missing_shipping_info = true;
                            modalOpen('modal-missing-shipping');
                        }
                    }
                } else {
                    OpenLink(r.custom_url);
                }
            })
            .catch(error => {
                s.checkout.messages = [];
                if (ppa_debug) {
                    logger.log(error);
                }
                if (s.checkout.cstep === ICheckoutStep.payment) {
                    s.checkout.messages.push({
                        msg: 'Payment Error. Check the credit card number.',
                        msgType: ICheckoutMessageType.payment,
                    });
                }
            });
    }

    function onError(err: any) {
        if (ppa_debug) {
            logger.log(err);
        }
        //   s.checkout.messages.push({
        //     msg: `Payment Error. ${err}.`,
        //     msgType: ICheckoutMessageType.payment,
        // });
    }

    // Nothing is due when a gift card or promo code covers the total: the same test as pay.cs skipPayment, which then
    // creates the 'gift' order with shipping and tax kept and answers custom_msg 'dd' (no order id), so
    // requestPayPalOrder() opens /view-order. The control reaches that path through the PayPal button; the redesign
    // offers a plain "Place Order" and never the MyFrames 'myf-place-order' path (that zeroes shipping and tax).
    const nothingDue = s.checkout.cart.pricing.total <= 0 && (s.checkout.code_gift_applied || s.checkout.code_promo_applied) && (s.checkout.cart.pricing.discount != 0 || s.checkout.cart.pricing.gift != 0);
    const coveredNote = coveredOrderNote(s.checkout.code_gift_applied && s.checkout.cart.pricing.gift != 0, s.checkout.code_promo_applied && s.checkout.cart.pricing.discount != 0);

    async function placeCoveredOrder() {
        if (s.uiCheckout.processing) {
            return;
        }
        s.uiCheckout.processing = true;
        let r: string | undefined;
        try {
            r = await requestPayPalOrder();
        } catch (error) {
            logger.log(error);
        }
        if (r === '') {
            // /view-order is opening. The button stays disabled: the order exists and the cart is gone, so a second
            // click must not post /api/pay/create again.
            return;
        }
        if (r) {
            // The server no longer saw the total as covered (gift balance used elsewhere, cart changed in another tab)
            // and created a PayPal order to approve instead; nothing was charged. Refresh the cart so the summary and
            // nothingDue follow the server, which brings the payment controls back, then say so.
            await checkout('get-cart');
            s.uiCheckout.processing = false;
            s.checkout.messages.push({
                msg: 'Your order total has changed. Please review your order and try again.',
                msgType: ICheckoutMessageType.payment,
            });
            return;
        }
        // Rejected: a server error (already in the messages) or a failed request. No card is involved here, so the
        // generic card wording of createOrder() does not apply.
        s.uiCheckout.processing = false;
        if (!s.checkout.messages.some(o => o.msgType === ICheckoutMessageType.payment)) {
            s.checkout.messages.push({
                msg: 'Your order could not be placed. Please try again or contact customer service.',
                msgType: ICheckoutMessageType.payment,
            });
        }
    }

    if (isCheckoutRedesign(s.checkout.isMyFrames)) {
        const payingWithCard = method === 'card';
        return (
            <PayPalScriptProvider options={initialOptions}>
                {/* One root element: the SDK and apple_init move or remove nodes in here, so React must only ever remove
                    this div. For the same reason the payment controls are hidden, not unmounted, while nothing is due. */}
                <div className={`ab-paypal${nothingDue ? ' ab-paypal-covered' : ''}`}>
                    <div
                        id="applepay-outer"
                        className="ab-applepay"
                    >
                        <div id="applepay-container"></div>
                    </div>

                    <div
                        className="ab-pay-methods"
                        role="radiogroup"
                        aria-label="Payment method"
                    >
                        <label className={`ab-pay-opt${method === 'paypal' ? ' is-selected' : ''}`}>
                            <input
                                type="radio"
                                name="ab-pay-method"
                                value="paypal"
                                checked={method === 'paypal'}
                                onChange={() => setMethod('paypal')}
                            />
                            <PayPalGlyph />
                            <span className="ab-pay-opt-title">PayPal</span>
                            <span
                                className="ab-pay-opt-mark"
                                aria-hidden={true}
                            />
                        </label>
                        <label className={`ab-pay-opt${payingWithCard ? ' is-selected' : ''}`}>
                            <input
                                type="radio"
                                name="ab-pay-method"
                                value="card"
                                checked={payingWithCard}
                                onChange={() => setMethod('card')}
                            />
                            <CreditCardGlyph />
                            <span className="ab-pay-opt-title">Credit card</span>
                            <span
                                className="ab-pay-opt-mark"
                                aria-hidden={true}
                            />
                        </label>
                    </div>

                    <PayPalCardFieldsProvider
                        createOrder={createOrder}
                        onApprove={onApprove}
                        onError={onError}
                    >
                        <div className={`ab-pay-card${payingWithCard ? '' : ' is-hidden'}`}>
                            {/* Labels and placeholders follow the design; the hosted fields carry their own required/optional semantics. */}
                            <div className="ab-pay-fields">
                                <div className="ab-pay-field ab-pay-field-wide">
                                    <label>Cardholder name</label>
                                    <PayPalNameField
                                        className="ab-pay-input"
                                        placeholder="Enter"
                                        style={cardFieldStyle}
                                    />
                                </div>
                                <div className="ab-pay-field ab-pay-field-wide">
                                    <label>Card number</label>
                                    <PayPalNumberField
                                        className="ab-pay-input"
                                        placeholder="Enter"
                                        style={cardFieldStyle}
                                    />
                                </div>
                                <div className="ab-pay-field">
                                    <PayPalExpiryField
                                        className="ab-pay-input"
                                        placeholder="MM/YY"
                                        style={cardFieldStyle}
                                    />
                                </div>
                                <div className="ab-pay-field">
                                    <PayPalCVVField
                                        className="ab-pay-input"
                                        placeholder="CVV"
                                        style={cardFieldStyle}
                                    />
                                </div>
                            </div>
                            <div className="ab-step-actions">
                                <SubmitPayment
                                    isPaying={isPaying}
                                    setIsPaying={setIsPaying}
                                    billingAddress={billingAddress}
                                />
                            </div>
                        </div>
                    </PayPalCardFieldsProvider>

                    {!payingWithCard && !nothingDue && (
                        <div className="ab-pay-paypal">
                            <PayPalButtons
                                createOrder={createOrder}
                                onApprove={onApprove}
                                onError={onError}
                                className={!s.uiCheckout.processing ? 'pay-center' : 'd-none'}
                                style={{tagline: false}}
                            />
                        </div>
                    )}

                    {nothingDue && (
                        <div className="ab-pay-covered">
                            <p className="ab-pay-covered-note">{coveredNote}</p>
                            <div className="ab-step-actions">
                                <button
                                    type="button"
                                    className="btn-checkout btn-checkout-yellow ab-pay-now"
                                    onClick={placeCoveredOrder}
                                    disabled={s.uiCheckout.processing}
                                    aria-busy={s.uiCheckout.processing}
                                    aria-label="Place Order"
                                >
                                    Place Order
                                    {s.uiCheckout.processing && (
                                        <span className="pad-left">
                                            <i
                                                className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"
                                                aria-hidden={true}
                                            ></i>
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </PayPalScriptProvider>
        );
    }

    return (
        <PayPalScriptProvider options={initialOptions}>
            <PayPalCardFieldsProvider
                createOrder={createOrder}
                onApprove={onApprove}
                onError={onError}
            >
                <div className="card-info"></div>

                <PayPalCardFieldsForm className="ppa-cc" />
                <SubmitPayment
                    isPaying={isPaying}
                    setIsPaying={setIsPaying}
                    billingAddress={billingAddress}
                />
            </PayPalCardFieldsProvider>
            <div style={{fontWeight: 400, fontSize: 18, textAlign: 'center', display: 'none', marginTop: 12, marginBottom: 24}}>
                Our payment system is currently down, please come back later to pay. Use promo code <span style={{fontWeight: 700}}>FunTimes</span> to save 5% when you come back!
            </div>
            <div style={{fontStyle: 'italic', fontSize: 14, textAlign: 'right', marginTop: 2}}>
                Your card will be charged <span style={{fontWeight: 700, fontStyle: 'normal'}}>{currency(s.checkout.cart.pricing.total < 0 ? 0 : s.checkout.cart.pricing.total)}</span>
            </div>
            <div className="pay-by-card">
                <div style={{margin: '0 auto', textAlign: 'center'}}>
                    <div className="pay-by-card-line"></div>
                </div>
                <div className="pay-by-card-text">or</div>
            </div>

            <div
                id="applepay-outer"
                style={{margin: '0 auto', marginBottom: 12, textAlign: 'center', width: '100%'}}
            >
                {<div id="applepay-container"></div>}
            </div>

            <div style={{margin: '0 auto', textAlign: 'center', width: '100%'}}>
                <PayPalButtons
                    createOrder={createOrder}
                    onApprove={onApprove}
                    onError={onError}
                    // onClick={onClickWhat}
                    className={!s.uiCheckout.processing ? 'pay-center' : 'd-none'}
                    style={{tagline: false}}
                />
            </div>
        </PayPalScriptProvider>
    );
}
